/**
 * KIRA Shopify Chat Widget + Interactive Effects
 * Inject into Shopify theme.liquid before </body>
 * Calls: POST https://api.kiragpt.com/shopify/chat
 */
(function () {
  /* ── CSS OVERRIDE INJECTION — fix CDN-cached rule conflicts ─── */
  (function injectOverrides() {
    var s = document.createElement('style');
    s.textContent = [
      /* Kill dark gradient from [class*="cta"] wildcard matching .kb-hero__ctas */
      '.shopify-section .kb-hero .kb-hero__ctas{background:transparent!important;background-image:none!important;position:static!important;overflow:visible!important}',
      '.shopify-section .kb-hero .kb-hero__ctas::before{display:none!important;content:none!important}',
      /* Hero CTA buttons gold gradient */
      '.shopify-section .kb-hero .kb-hero__cta-primary{background:linear-gradient(135deg,#B8915A 0%,#D4AA7D 50%,#B8915A 100%)!important;background-size:200% 200%!important;color:#fff!important;border:none!important;box-shadow:0 4px 18px rgba(184,145,90,0.45)!important}',
      '.shopify-section .kb-hero .kb-hero__cta-secondary{background:rgba(22,18,14,0.82)!important;color:#B8915A!important;border:1.5px solid rgba(184,145,90,0.45)!important}',
      /* FIX: .kb-why dark section — black text on dark bg, make it light */
      '.kb-why{color:#F9F7F4!important}',
      '.kb-why h2,.kb-why h3,.kb-why h4{color:#F9F7F4!important}',
      '.kb-why p,.kb-why li{color:rgba(249,247,244,0.80)!important}',
      '.kb-why [class*="card"],.kb-why [class*="feature"],.kb-why [class*="item"]{color:#F9F7F4!important}',
      '.kb-why [class*="card"] h3,.kb-why [class*="feature"] h3,.kb-why [class*="item"] h3{color:#F9F7F4!important}',
      '.kb-why [class*="card"] p,.kb-why [class*="feature"] p{color:rgba(249,247,244,0.75)!important}',
      /* Social proof bar */
      '#kb-trust-bar{position:fixed;top:0;left:0;right:0;z-index:9990;background:#16120E;color:#F9F7F4;font-size:12px;font-weight:500;text-align:center;padding:7px 16px;letter-spacing:0.04em;display:flex;align-items:center;justify-content:center;gap:18px;font-family:"DM Sans",-apple-system,sans-serif}',
      '#kb-trust-bar .kb-stars{color:#B8915A;font-size:13px;letter-spacing:1px}',
      '#kb-trust-bar .kb-sep{opacity:0.3}',
      '#kb-trust-bar a{color:#B8915A;text-decoration:none;font-weight:600}',
      '#kb-trust-bar a:hover{text-decoration:underline}',
      '#kb-trust-bar .kb-close-bar{margin-left:auto;background:none;border:none;color:rgba(249,247,244,0.5);cursor:pointer;font-size:16px;line-height:1;padding:0 4px}'
    ].join('');
    document.head.appendChild(s);
  })();

  /* ── SOCIAL PROOF TRUST BAR ──────────────────────── */
  (function injectTrustBar() {
    if (sessionStorage.getItem('kb_bar_closed')) return;
    var bar = document.createElement('div');
    bar.id = 'kb-trust-bar';
    bar.innerHTML =
      '<span class="kb-stars">&#9733;&#9733;&#9733;&#9733;&#9733;</span>' +
      '<span><strong>4.7 / 5</strong> &mdash; Rated by 40+ buyers</span>' +
      '<span class="kb-sep">|</span>' +
      '<span>Instant download &bull; Works immediately &bull; No setup needed</span>' +
      '<button class="kb-close-bar" title="Dismiss">&times;</button>';
    document.body.insertBefore(bar, document.body.firstChild);
    bar.querySelector('.kb-close-bar').addEventListener('click', function() {
      bar.style.display = 'none';
      sessionStorage.setItem('kb_bar_closed', '1');
    });
  })();

  /* ── 3D TILT + SCROLL REVEAL ─────────────────────── */
  function initEffects() {
    // IntersectionObserver scroll reveal — generous margins so sections never stay hidden
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0) scale(1)';
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.05, rootMargin: '0px 0px 80px 0px' });

    var revealEls = document.querySelectorAll(
      '.shopify-section:not(:first-child):not([data-section-type="featured-collection"]):not([class*="dbtfy"])'
    );
    revealEls.forEach(function(el) {
      if (!el.querySelector('.product-item, .grid-product')) {
        el.style.transition = 'opacity 0.7s cubic-bezier(0.16,1,0.3,1), transform 0.7s cubic-bezier(0.16,1,0.3,1)';
        el.style.opacity = '0';
        el.style.transform = 'translateY(24px)';
        observer.observe(el);
      }
    });

    // Fallback: reveal all hidden sections after 2s in case IntersectionObserver misfires
    setTimeout(function() {
      revealEls.forEach(function(el) {
        if (el.style.opacity === '0') {
          el.style.opacity = '1';
          el.style.transform = 'translateY(0) scale(1)';
        }
      });
    }, 2000);

    // 3D mouse-tilt on product cards
    var cards = document.querySelectorAll('.product-item, .grid-product, .product-card');
    cards.forEach(function(card) {
      card.addEventListener('mousemove', function(e) {
        var rect = card.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width  - 0.5;
        var y = (e.clientY - rect.top)  / rect.height - 0.5;
        var tiltX =  y * 10;
        var tiltY = -x * 10;
        card.style.transform = 'translateY(-10px) rotateX(' + tiltX + 'deg) rotateY(' + tiltY + 'deg) scale(1.02)';
        card.style.boxShadow =
          '0 ' + (24 + Math.abs(tiltX)) + 'px 64px rgba(22,18,14,0.14),' +
          '0 10px 24px rgba(184,145,90,0.18),' +
          '0 0 0 1px rgba(184,145,90,0.28)';
      });
      card.addEventListener('mouseleave', function() {
        card.style.transform = '';
        card.style.boxShadow = '';
      });
    });

    // Hero floating particles
    var hero = document.querySelector('.shopify-section:first-child');
    if (hero) {
      hero.style.position = 'relative';
      hero.style.overflow = 'hidden';
      for (var i = 0; i < 8; i++) {
        var p = document.createElement('div');
        var sz = 3 + Math.random() * 5;
        var left = 5 + Math.random() * 90;
        var dur = 6 + Math.random() * 8;
        var delay = Math.random() * 4;
        p.style.cssText =
          'position:absolute;border-radius:50%;pointer-events:none;z-index:0;' +
          'width:' + sz + 'px;height:' + sz + 'px;' +
          'background:rgba(184,145,90,' + (0.15 + Math.random() * 0.2) + ');' +
          'left:' + left + '%;bottom:-10px;' +
          'animation:kbFloat ' + dur + 's ease-in-out ' + delay + 's infinite;';
        hero.appendChild(p);
      }
      if (!document.getElementById('kb-particle-style')) {
        var s = document.createElement('style');
        s.id = 'kb-particle-style';
        s.textContent =
          '@keyframes kbFloat{' +
          '0%{transform:translateY(0) scale(1);opacity:0;}' +
          '10%{opacity:1;}' +
          '90%{opacity:0.6;}' +
          '100%{transform:translateY(-110vh) scale(0.5);opacity:0;}' +
          '}';
        document.head.appendChild(s);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEffects);
  } else {
    initEffects();
  }


  var CHAT_API = 'https://api.kiragpt.com/shopify/chat';
  var SESSION_KEY = 'kira_chat_session';

  // Generate or retrieve session ID
  function getSessionId() {
    var id = localStorage.getItem(SESSION_KEY);
    if (!id) {
      id = 'sess_' + Math.random().toString(36).slice(2) + Date.now();
      localStorage.setItem(SESSION_KEY, id);
    }
    return id;
  }

  // Build widget HTML
  var css = `
    #kira-chat-btn{position:fixed;bottom:24px;right:24px;width:56px;height:56px;background:#16120E;border-radius:50%;border:none;cursor:pointer;box-shadow:0 4px 16px rgba(22,18,14,.3);z-index:9998;display:flex;align-items:center;justify-content:center;transition:transform .2s,background .2s}
    #kira-chat-btn:hover{background:#B8915A;transform:scale(1.08)}
    #kira-chat-btn svg{width:26px;height:26px;fill:#F9F7F4}
    #kira-chat-box{position:fixed;bottom:92px;right:24px;width:340px;max-height:480px;background:#fff;border-radius:16px;box-shadow:0 8px 32px rgba(22,18,14,.18);z-index:9999;display:none;flex-direction:column;overflow:hidden;font-family:'DM Sans',-apple-system,BlinkMacSystemFont,sans-serif}
    #kira-chat-box.open{display:flex}
    #kira-chat-header{background:#16120E;color:#F9F7F4;padding:14px 18px;font-weight:600;font-size:14px;display:flex;align-items:center;gap:10px}
    #kira-chat-header span.dot{width:8px;height:8px;background:#B8915A;border-radius:50%;display:inline-block}
    #kira-chat-close{margin-left:auto;background:none;border:none;color:#F9F7F4;cursor:pointer;font-size:20px;line-height:1;padding:0;opacity:.7;transition:opacity .15s}
    #kira-chat-close:hover{opacity:1}
    #kira-chat-messages{flex:1;overflow-y:auto;padding:14px;display:flex;flex-direction:column;gap:10px;min-height:120px;background:#F9F7F4}
    .kira-msg{max-width:82%;padding:10px 14px;border-radius:14px;font-size:13.5px;line-height:1.5}
    .kira-msg.bot{background:#ffffff;color:#16120E;border-bottom-left-radius:4px;align-self:flex-start;box-shadow:0 1px 4px rgba(22,18,14,.08)}
    .kira-msg.user{background:#16120E;color:#F9F7F4;border-bottom-right-radius:4px;align-self:flex-end}
    .kira-typing{align-self:flex-start;font-size:12px;color:#888;padding:4px 14px}
    #kira-chat-input-row{display:flex;border-top:1px solid #e8e4df;padding:10px;background:#fff}
    #kira-chat-input{flex:1;border:1px solid #e8e4df;border-radius:8px;padding:8px 12px;font-size:13px;outline:none;resize:none;font-family:inherit}
    #kira-chat-input:focus{border-color:#B8915A}
    #kira-chat-send{background:#B8915A;color:#fff;border:none;border-radius:8px;padding:8px 14px;margin-left:8px;cursor:pointer;font-size:13px;font-weight:600;transition:background .15s}
    #kira-chat-send:hover{background:#9a7a4a}
    #kira-chat-send:disabled{opacity:.5;cursor:default}
  `;

  var styleEl = document.createElement('style');
  styleEl.textContent = css;
  document.head.appendChild(styleEl);

  var html = `
    <button id="kira-chat-btn" title="Chat with us">
      <svg viewBox="0 0 24 24"><path d="M20 2H4a2 2 0 00-2 2v18l4-4h14a2 2 0 002-2V4a2 2 0 00-2-2z"/></svg>
    </button>
    <div id="kira-chat-box">
      <div id="kira-chat-header">
        <span class="dot"></span> Store Assistant
        <button id="kira-chat-close">&times;</button>
      </div>
      <div id="kira-chat-messages"></div>
      <div id="kira-chat-input-row">
        <textarea id="kira-chat-input" rows="1" placeholder="Ask me anything..."></textarea>
        <button id="kira-chat-send">Send</button>
      </div>
    </div>
  `;

  var wrapper = document.createElement('div');
  wrapper.innerHTML = html;
  document.body.appendChild(wrapper);

  var btn = document.getElementById('kira-chat-btn');
  var box = document.getElementById('kira-chat-box');
  var closeBtn = document.getElementById('kira-chat-close');
  var msgs = document.getElementById('kira-chat-messages');
  var input = document.getElementById('kira-chat-input');
  var sendBtn = document.getElementById('kira-chat-send');
  var sessionId = getSessionId();
  var opened = false;

  function addMsg(text, role) {
    var el = document.createElement('div');
    el.className = 'kira-msg ' + role;
    el.textContent = text;
    msgs.appendChild(el);
    msgs.scrollTop = msgs.scrollHeight;
  }

  function setTyping(show) {
    var existing = document.querySelector('.kira-typing');
    if (show && !existing) {
      var t = document.createElement('div');
      t.className = 'kira-typing';
      t.textContent = 'Typing...';
      msgs.appendChild(t);
      msgs.scrollTop = msgs.scrollHeight;
    } else if (!show && existing) {
      existing.remove();
    }
  }

  async function sendMessage() {
    var text = input.value.trim();
    if (!text || sendBtn.disabled) return;
    input.value = '';
    addMsg(text, 'user');
    sendBtn.disabled = true;
    setTyping(true);
    try {
      var r = await fetch(CHAT_API, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({session_id: sessionId, message: text})
      });
      var data = await r.json();
      setTyping(false);
      addMsg(data.reply || 'Sorry, something went wrong.', 'bot');
    } catch (e) {
      setTyping(false);
      addMsg('Connection error. Please try again.', 'bot');
    }
    sendBtn.disabled = false;
    input.focus();
  }

  btn.addEventListener('click', function () {
    box.classList.toggle('open');
    if (!opened) {
      opened = true;
      setTimeout(function () {
        addMsg('Hi! I can help you find the perfect digital product. What are you looking for today?', 'bot');
      }, 300);
    }
  });

  closeBtn.addEventListener('click', function () { box.classList.remove('open'); });
  sendBtn.addEventListener('click', sendMessage);
  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); sendMessage(); }
  });
})();
